/* eslint-disable @typescript-eslint/ban-ts-comment */
import { initializeApollo } from 'lib/apollo/initializeApolloClient';
import { addApolloState } from 'lib/apollo/withApolloClient';
import runQuery from 'lib/utils/runQuery';
import { EXCLUDE_WP_CATEGORIES, INSPIRATION_WP_CATEGORY_ID } from 'shared/utils/constants';
import InspirationSearch from 'src/pages/oneflare.com.au/Inspiration/Search/Search';
import { SEARCH_POSTS } from 'src/queries/oneflare.com.au/inspiration';
import { GET_WP_CATEGORY_WITH_PARENT } from 'src/queries/oneflare.com.au/wpGetCategoryWithParent';

const SeachTermPage = (props) => {
  const { router } = props;
  return (
    <InspirationSearch {...props} pageUrl={router.asPath} />
  );
};

export async function getServerSideProps(ctx) {
  const { query: params } = ctx;
  const { term } = params;
  const apolloClient = initializeApollo(ctx, null);
  let wpData;
  let initialData;
  const topLevelCategoryDataQuery = runQuery({
    query: GET_WP_CATEGORY_WITH_PARENT,
    params: {
      parent: INSPIRATION_WP_CATEGORY_ID,
      orderby: 'description'
    },
    apolloClient
  });

  const initialDataQuery = runQuery({
    query: SEARCH_POSTS,
    params: {
      search: term,
      limit: 100,
      exclude: 0,
      order: 'desc',
      orderby: 'date',
      categoriesExclude: EXCLUDE_WP_CATEGORIES,
      categories: '',
      tags: '',
      sticky: false
    },
    apolloClient
  });

  await Promise
    .allSettled([topLevelCategoryDataQuery, initialDataQuery])
    // @ts-ignore
    .then((settled) => settled.filter((post) => post.status === 'fulfilled').map((content) => content?.value))
    .then((content) => {
      [, initialData] = content;
      wpData = {
        topLevelCategoryData: content[0]?.getCategory
      };
    });

  return addApolloState(apolloClient, {
    props: {
      params,
      initialData: initialData ?? {},
      wpData
    }
  });
}

export default SeachTermPage;
